import React, { useState } from 'react';
import UsersView from './UsersView.js';
import RolesView from './RolesView.js';

// --------------------------------------------------------------------------
// Pantalla unificada "Usuarios y Roles" (Equipo y Accesos).
//
// Antes Usuarios y Roles eran dos entradas separadas del menú, pero ambas
// gestionan lo mismo (RolesView también asigna roles a usuarios). Aquí se
// consolidan en una sola pantalla con pestañas. Cada pestaña solo aparece si el
// usuario tiene el permiso correspondiente, así que un usuario con un solo
// permiso ve una sola pestaña.
// --------------------------------------------------------------------------

export default function TeamAccessView({ db, user, initialTab = 'users' }) {
    const canUsers = !!user?.permissions?.canManageUsers;
    const canRoles = !!user?.permissions?.canManageRoles;

    const tabs = [
        canUsers && { id: 'users', label: 'Usuarios' },
        canRoles && { id: 'roles', label: 'Roles y Permisos' },
    ].filter(Boolean);

    const validInitial = tabs.some((t) => t.id === initialTab) ? initialTab : tabs[0]?.id;
    const [active, setActive] = useState(validInitial);

    if (tabs.length === 0) {
        return (
            <div className="p-8">
                <h1 className="text-3xl font-bold text-red-600">Acceso Denegado</h1>
                <p>No tienes permiso para gestionar usuarios ni roles.</p>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="px-8 pt-8">
                <h1 className="text-3xl font-bold text-gray-800">Usuarios y Roles</h1>
                <p className="text-gray-600 mt-1">Gestiona el acceso del equipo: cuentas, roles y permisos.</p>
                <div className="mt-6 border-b border-gray-200 flex gap-1">
                    {tabs.map((t) => (
                        <button
                            key={t.id}
                            onClick={() => setActive(t.id)}
                            className={`px-5 py-2.5 text-sm font-semibold rounded-t-lg border-b-2 -mb-px transition-colors ${
                                active === t.id
                                    ? 'border-blue-600 text-blue-700 bg-white'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Cada vista trae su propio layout/encabezado interno. */}
            {active === 'users' && canUsers && <UsersView />}
            {active === 'roles' && canRoles && <RolesView db={db} />}
        </div>
    );
}
